import { use } from "i18next";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { SplashScreen } from "src/components/loading-screen";
import { useGetWorkspacesQuery } from "src/context/api/workspaces";
import { setCurrentWorkspace, useCurrentWorkspace } from "src/context/reducers/app-settings";

interface Props {
    children: React.ReactNode;
}

export default function WorkspaceGuard(props: Props) {
    const workspaces = useGetWorkspacesQuery(null);
    const workspace = useCurrentWorkspace();
    const [searchParams, setSearchParams] = useSearchParams()
    const dispatch = useDispatch();

    // Merge the workspace id into the current query string instead of replacing it:
    // deep links (e.g. Brand Infringement -> Ads with ?country/?domain/?search_term)
    // arrive without a workspace param and must keep their own params.
    const setWorkspaceParam = useCallback((workspaceId: number | string) => {
        setSearchParams((current) => {
            const next = new URLSearchParams(current);
            next.set('workspace', workspaceId.toString());
            return next;
        });
    }, [setSearchParams]);

    useEffect(() => {
        if (workspace && !searchParams.has('workspace')) {
            setWorkspaceParam(workspace.id)
        }
        else if (searchParams.has('workspace')) {
            const _workspace = workspaces?.data?.find((w) => w.id == Number(searchParams.get('workspace')))
            if (_workspace) {
                dispatch(setCurrentWorkspace(_workspace))
            }
        }
        else if (!searchParams.has('workspace') && workspaces.data && workspaces.data.length > 1) {
            setWorkspaceParam(workspaces.data[0].id);
            dispatch(setCurrentWorkspace(workspaces.data[0]));
        }

    }, [workspace, searchParams, workspaces])

    useEffect(() => {
        if (workspaces.data && workspaces.data.length === 1) {
            dispatch(setCurrentWorkspace(workspaces.data[0]));
            setWorkspaceParam(workspaces.data[0].id);
        }
    }, [workspaces, dispatch, setWorkspaceParam]);


    if (workspaces.isLoading || workspaces.isFetching || workspaces.isUninitialized) {
        return <SplashScreen />
    }

    return <>{props.children}</>
}